import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import $ from "jquery";
import fetch from "isomorphic-fetch";
import db from "../dbconn";
import {API_ROOT} from "../api-config";
import Modal from 'react-responsive-modal';
import Notifications, {notify} from 'react-notify-toast';
import Swal from "sweetalert2";
import Language from "./language";
import moment from 'moment';
import axios from "axios";
import {withTranslation} from 'react-i18next';
import i18n from "i18next";


class view_order extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            redirect: false,
            nosessionredirect: false,
            windowHeight: 0,
            timingStatus: 0,
            open: false,
            order_id: this.props.match.params.orderId,
            productList: [],
            nca: 0,
            ncaAmtFlag: false,
            deleteG: false,
            ncaAmtName: '',
            tax: [],
            categoryList: [],
            editItemRedirectFlag: false,
            checkoutRedirectFlag: false,
            editItemProductID: 0,
            editItemCartID: 0,
            cartTotal: 0,
            subTotal: 0,
            finalTax: 0,
            guestRedirectFlag: false,
            swalButton: '',
            swalTable: '',
            sealCurbside: '',
            storeOrderType: '',
            storeDeliveryFee: 0,
            storeDeliveryFeeDiscount: 0,
            orderTypeDialog: '',
            homeRedirectFlag: false,
            resizeFlag: true,
            resizeCount: 0,
            tip1Visible: "inline-block",
            tip2Visible: "inline-block",
            tip3Visible: "inline-block",
            customTipVisible: "none",
            noTipVisible: "inline-block",
            tip1: 0,
            tip2: 0,
            tip3: 0,
            tipType: "P",
            tipEnabled: false,
            tipSelected: 0,
            tip: 0,
            customTip: 0,
            storeDeliveryTime: '',
            storePickupTime: '',
            storeWeeklyOrder: '',
            alertDialog: '',
            ncaMarkup: "N",
            dineInFlag: "N",
            ncaOnTipEnabled: "Y",
            totalLoyaltyPoints: 0,
            couponApplied: "N",
            couponType: "",
            couponDiscount: 0,
            couponMinSubtotal: 0
        };
    };


    onOpenModal = () => {
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };
    cancelCoupon = () => {

        var dbconn = new db();

        dbconn.deleteAllCouponOrder("G").then(db1 => {
            dbconn.deleteAllCouponOrder("H").then(db1 => {
                dbconn.getAllOrder().then(productData => {

                    productData.map((item, index) => {


                        // dbconn.deleteOrder(parseInt(item.cart_id)).then(data => {
                        var dbconn = new db();
                        dbconn.setOrder({
                            product_name: item.product_name,
                            product_name_es: item.product_name_es,
                            product_desc_es: item.product_desc_es,
                            product_desc: item.product_desc,
                            product_id: item.product_id,
                            product_img: item.product_img,
                            product_quantity: item.product_quantity,
                            product_notes: item.product_notes,
                            product_price: item.product_price,
                            product_original_price: item.product_original_price,
                            product_discount: 0,
                            product_discount_type: "",
                            product_modifiers: item.product_modifiers,
                            product_loyalty_enabled: item.product_loyalty_enabled,
                            product_loyalty_price: item.product_loyalty_price,
                            mod_price: item.mod_price,
                            mod_original_price: item.mod_original_price,
                            isModifierAvailable: item.isModifierAvailable,
                            cart_id: item.cart_id
                        }, item.cart_id).then(data => {

                        });
                        // });

                    });


                    sessionStorage.removeItem("couponApplied");
                    sessionStorage.removeItem("couponID");
                    sessionStorage.removeItem("couponCode");
                    sessionStorage.removeItem("couponType");
                    sessionStorage.removeItem("couponMinSubtotal");
                    sessionStorage.removeItem("couponDeliveryType");
                    sessionStorage.removeItem("couponDiscount");
                    sessionStorage.removeItem("couponProductDetails");
                    sessionStorage.removeItem("couponDiscountedProductDetails");
                    $('#couponInput').val('');
                    $('#couponInputContainer').css('display', 'inline-table');
                    $('#appliedCouponContainer').css('display', 'none');
                    this.setState({couponApplied: "N"});
                    this.setState({couponType: ""});
                    this.setState({couponDiscount: 0});
                    this.setState({couponMinSubtotal: 0});
                    var dbconn = new db();
                    dbconn.getAllOrder().then(productData => {

                        var totalLoyalty = 0;
                        productData.forEach(function (product) {

                            if (product.product_loyalty_enabled == "Y") {
                                totalLoyalty += parseInt(product.product_loyalty_price);
                            }
                        });

                        this.setState({totalLoyaltyPoints: totalLoyalty});

                        this.calculateModifiers(productData);
                        //this.setState({productList: productData});
                        this.calculateCartTotal(false);
                    });

                });
            });
        });


    };

    addCoupon = () => {

        if ($('#couponInput').val().trim().length <= 0) {

            this.state.swalButton.fire({
                title: i18n.t('enter_coupon_code'),
                allowOutsideClick: false
            });

        } else {


            this.onOpenModal();

            if (sessionStorage.getItem('guestFlag') == 'Y') {

                var subtotal = sessionStorage.getItem("cartTotal");
                var url = API_ROOT + '/verifycoupon?guestFlag=Y&store_id=' + localStorage.getItem('store_id') + "&coupon=" + $('#couponInput').val().trim() + "&timezone=" + moment.tz.guess() + "&subtotal=" + subtotal;

                fetch(url)
                    .then(response => {
                        return response.json();
                    })
                    .then(coupon => {

                        this.onCloseModal();
                        if (coupon.status == 1) {


                            sessionStorage.setItem("couponApplied", "Y");
                            sessionStorage.setItem("couponID", coupon.coupon[0].coupon_id);
                            sessionStorage.setItem("couponCode", coupon.coupon[0].coupon_code.toUpperCase());
                            sessionStorage.setItem("couponType", coupon.coupon[0].coupon_type);
                            sessionStorage.setItem("couponMinSubtotal", coupon.coupon[0].coupon_min_subtotal);
                            sessionStorage.setItem("couponDeliveryType", coupon.coupon[0].coupon_delivery_type);
                            sessionStorage.setItem("couponDiscount", coupon.coupon[0].coupon_discount);
                            sessionStorage.setItem("couponProductDetails", coupon.coupon[0].product_details);
                            sessionStorage.setItem("couponDiscountedProductDetails", coupon.coupon[0].product_discounted_details);


                            $('#couponInputContainer').css('display', 'none');
                            $('#appliedCouponContainer').css('display', 'inline-table');
                            $('#appliedCouponText').html(coupon.coupon[0].coupon_code.toUpperCase());

                            this.setState({deleteG: true});
                            this.calculateCoupon();

                        } else {
                            this.state.swalButton.fire({
                                title: coupon.message,
                                allowOutsideClick: false
                            });

                        }
                    });
            } else {

                var dbconn = new db();

                dbconn.getAll().then(data => {

                    if (!data || data.length < 1) {
                        this.setState({nosessionredirect: true});
                    } else {
                        var customer_id = data[0].customer_id;
                        var customer_token = data[0].customer_token;

                        var subtotal = sessionStorage.getItem("cartTotal");
                        this.onOpenModal();
                        url = API_ROOT + '/verifycoupon?guestFlag=N&customer_id=' + customer_id + '&customer_token=' + customer_token + '&store_id=' + localStorage.getItem('store_id') + "&coupon=" + $('#couponInput').val().trim() + "&timezone=" + moment.tz.guess() + "&subtotal=" + subtotal;


                        fetch(url)
                            .then(response => {
                                return response.json();
                            })
                            .then(coupon => {

                                this.onCloseModal();
                                if (coupon.status == 1) {

                                    sessionStorage.setItem("couponApplied", "Y");
                                    sessionStorage.setItem("couponID", coupon.coupon[0].coupon_id);
                                    sessionStorage.setItem("couponCode", coupon.coupon[0].coupon_code.toUpperCase());
                                    sessionStorage.setItem("couponType", coupon.coupon[0].coupon_type);
                                    sessionStorage.setItem("couponMinSubtotal", coupon.coupon[0].coupon_min_subtotal);
                                    sessionStorage.setItem("couponDeliveryType", coupon.coupon[0].coupon_delivery_type);
                                    sessionStorage.setItem("couponDiscount", coupon.coupon[0].coupon_discount);
                                    sessionStorage.setItem("couponProductDetails", coupon.coupon[0].product_details);
                                    sessionStorage.setItem("couponDiscountedProductDetails", coupon.coupon[0].product_discounted_details);
                                    $('#couponInputContainer').css('display', 'none');
                                    $('#appliedCouponContainer').css('display', 'inline-table');
                                    $('#appliedCouponText').html(coupon.coupon[0].coupon_code.toUpperCase());
                                    this.setState({deleteG: true});
                                    this.calculateCoupon();

                                } else {
                                    this.state.swalButton.fire({
                                        title: coupon.message,
                                        allowOutsideClick: false
                                    });

                                }
                            });

                    }
                });

            }


        }
    };

    componentDidUpdate(prevProps, prevState, snapshot) {


    }

    componentWillMount() {
        if(!localStorage.getItem("store_language")){
            localStorage.setItem("store_language","en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });

        document.title = "View Order - " + localStorage.getItem("store_name") + " - Order Anywhere";
        sessionStorage.removeItem('editCartID');
        window.addEventListener('resize', this.onResize);
        this.setState({
            swalButton: Swal.mixin({
                customClass: {
                    confirmButton: 'link_button',
                    cancelButton: 'link_button'
                },
                buttonsStyling: false,
            })
        });
        this.setState({
            swalTable: Swal.mixin({
                customClass: {
                    confirmButton: 'link_button',
                    cancelButton: 'link_button'
                },
                buttonsStyling: false,
            })
        });
        this.setState({
            swalCurbside: Swal.mixin({
                customClass: {
                    confirmButton: 'link_button',
                    cancelButton: 'link_button'
                },
                buttonsStyling: false,
            })
        });
        this.setState({
            alertDialog: Swal.mixin({
                customClass: {
                    confirmButton: 'link_button',
                    cancelButton: 'link_button'
                },
                buttonsStyling: false,
            })
        });
        this.setState({
            orderTypeDialog: Swal.mixin({
                customClass: {
                    confirmButton: 'link_button',
                    cancelButton: 'new_line_button',


                },

                buttonsStyling: false,
            })
        });
        var url = '';

        var cartTotal = parseFloat(sessionStorage.getItem('cartTotal'));

        this.setState({cartTotal: (isNaN(cartTotal)) ? 0 : cartTotal});


        if (sessionStorage.getItem('guestFlag') == 'Y') {

            this.onOpenModal();
            url = API_ROOT + '/fetchstorestats?guestFlag=Y&store_id=' + localStorage.getItem('store_id');

            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(storeData => {

                    this.onCloseModal();
                    if (storeData.status == 1) {

                        this.setState({nca: storeData.store_data[0].store_default_nca});
                        this.setState({ncaAmtFlag: storeData.store_data[0].store_nca_amount_flag});
                        this.setState({ncaAmtName: storeData.store_data[0].store_nca_name});
                        this.setState({ncaMarkup: storeData.store_data[0].store_product_markup_enabled});
                        this.setState({storeOrderType: storeData.store_data[0].store_order_type});
                        this.setState({storeDeliveryFee: parseFloat(storeData.store_data[0].store_delivery_fee)});
                        this.setState({storeDeliveryFeeDiscount: parseFloat(storeData.store_data[0].store_delivery_fee)});
                        this.setState({ncaOnTipEnabled: storeData.store_data[0].store_tip_nca_enabled});
                        this.setState({storeWeeklyOrder: storeData.store_data[0].store_weekly_order});
                        this.setState({storeDeliveryTime: storeData.store_data[0].store_delivery_time});
                        this.setState({storePickupTime: storeData.store_data[0].store_pickup_time});


                        if (storeData.store_data[0].store_tip_enabled == "Y") {
                            this.setState({tipEnabled: true});

                            this.setState({tip1: storeData.store_data[0].store_default_tip1});
                            this.setState({tip2: storeData.store_data[0].store_default_tip2});
                            this.setState({tip3: storeData.store_data[0].store_default_tip3});

                            if (this.state.tip1 == 0) {
                                this.setState({tip1Visible: "none"});
                            } else {
                                this.setState({tip1Visible: "inline-block"});
                            }

                            if (this.state.tip2 == 0) {
                                this.setState({tip2Visible: "none"});
                            } else {
                                this.setState({tip2Visible: "inline-block"});
                            }
                            if (this.state.tip3 == 0) {
                                this.setState({tip3Visible: "none"});
                            } else {
                                this.setState({tip3Visible: "inline-block"});
                            }

                            if (this.state.tip1 == 0 && this.state.tip2 == 0 && this.state.tip3 == 0) {
                                this.setState({customTipVisible: "none"});
                                this.setState({notTipVisible: 'inline-bloack'});
                            } else {
                                this.setState({customTipVisible: "none"});
                                this.setState({notTipVisible: 'inline-block'});
                            }

                            console.log("TIP: " + this.state.tip1);
                        } else {
                            this.setState({tipEnabled: false});
                        }

                        var taxArray = storeData.store_data[0].store_taxes;

                        var totalTax = 0;

                        for (var i = 0; i < taxArray.length; i++) {

                            var tax = ((parseFloat(this.state.cartTotal) * parseFloat(taxArray[i].tax_percentage)) / 100);


                            taxArray[i].tax_value = tax.toFixed(2);

                            totalTax += parseFloat(tax.toFixed(2));
                        }


                        this.setState({tax: taxArray});
                        this.setState({finalTax: totalTax.toFixed(2)});
                        this.calculateCoupon();


                    }
                });

            var dbconn = new db();
            dbconn.getAllOrder().then(productData => {

                var totalLoyalty = 0;
                productData.forEach(function (product) {

                    if (product.product_loyalty_enabled == "Y") {
                        totalLoyalty += parseInt(product.product_loyalty_price);
                    }
                });

                this.setState({totalLoyaltyPoints: totalLoyalty});

                this.calculateModifiers(productData);
                //this.setState({productList: productData});
            });

        } else {
            var dbconn = new db();

            dbconn.getAll().then(data => {

                if (!data || data.length < 1) {
                    this.setState({nosessionredirect: true});
                } else {
                    var customer_id = data[0].customer_id;
                    var customer_token = data[0].customer_token;

                    this.onOpenModal();
                    url = API_ROOT + '/fetchstorestats?guestFlag=N&customer_id=' + customer_id + '&customer_token=' + customer_token + '&store_id=' + localStorage.getItem('store_id');

                    fetch(url)
                        .then(response => {
                            return response.json();
                        })
                        .then(storeData => {

                            this.onCloseModal();
                            if (storeData.status == 1) {

                                this.setState({nca: storeData.store_data[0].store_default_nca});
                                this.setState({ncaAmtFlag: storeData.store_data[0].store_nca_amount_flag});
                                this.setState({tax: storeData.store_data[0].store_taxes});
                                this.setState({ncaAmtName: storeData.store_data[0].store_nca_name});
                                this.setState({ncaMarkup: storeData.store_data[0].store_product_markup_enabled});
                                this.setState({storeOrderType: storeData.store_data[0].store_order_type});
                                this.setState({storeDeliveryFee: parseFloat(storeData.store_data[0].store_delivery_fee)});
                                this.setState({storeDeliveryFeeDiscount: parseFloat(storeData.store_data[0].store_delivery_fee)});
                                this.setState({storeWeeklyOrder: storeData.store_data[0].store_weekly_order});
                                this.setState({ncaOnTipEnabled: storeData.store_data[0].store_tip_nca_enabled});
                                this.setState({storeDeliveryTime: storeData.store_data[0].store_delivery_time});
                                this.setState({storePickupTime: storeData.store_data[0].store_pickup_time});

                                if (storeData.store_data[0].store_tip_enabled == "Y") {
                                    this.setState({tipEnabled: true});

                                    this.setState({tip1: storeData.store_data[0].store_default_tip1});
                                    this.setState({tip2: storeData.store_data[0].store_default_tip2});
                                    this.setState({tip3: storeData.store_data[0].store_default_tip3});

                                    if (this.state.tip1 == 0) {
                                        this.setState({tip1Visible: "none"});
                                    } else {
                                        this.setState({tip1Visible: "inline-block"});
                                    }

                                    if (this.state.tip2 == 0) {
                                        this.setState({tip2Visible: "none"});
                                    } else {
                                        this.setState({tip2Visible: "inline-block"});
                                    }
                                    if (this.state.tip3 == 0) {
                                        this.setState({tip3Visible: "none"});
                                    } else {
                                        this.setState({tip3Visible: "inline-block"});
                                    }

                                    if (this.state.tip1 == 0 && this.state.tip2 == 0 && this.state.tip3 == 0) {
                                        this.setState({customTipVisible: "none"});
                                        this.setState({notTipVisible: 'inline-bloack'});
                                    } else {
                                        this.setState({customTipVisible: "none"});
                                        this.setState({notTipVisible: 'inline-block'});
                                    }

                                    console.log("TIP: " + this.state.tip1);
                                } else {
                                    this.setState({tipEnabled: false});
                                }

                                var taxArray = this.state.tax;

                                var totalTax = 0;

                                for (var i = 0; i < taxArray.length; i++) {

                                    var tax = ((parseFloat(this.state.cartTotal) * parseFloat(taxArray[i].tax_percentage)) / 100);


                                    taxArray[i].tax_value = tax.toFixed(2);

                                    totalTax += parseFloat(tax.toFixed(2));
                                }

                                this.setState({tax: taxArray});
                                this.setState({finalTax: totalTax.toFixed(2)});
                                this.calculateCoupon();

                            }
                        });


                    dbconn.getAllOrder().then(productData => {
                        var totalLoyalty = 0;
                        productData.forEach(function (product) {

                            if (product.product_loyalty_enabled == "Y") {
                                totalLoyalty += parseInt(product.product_loyalty_price);
                            }
                        });

                        this.setState({totalLoyaltyPoints: totalLoyalty});
                        this.calculateModifiers(productData);
                        //this.setState({productList: productData});
                    });


                }
            });
        }
    }

    componentDidMount() {

        document.title = "View Cart - " + localStorage.getItem("store_name") + " - Order Anywhere";

        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }
        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }
        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }

        if (sessionStorage.getItem("couponID")) {
            $('#couponInput').val('');
            $('#appliedCouponText').html(sessionStorage.getItem("couponCode"))
            $('#couponInputContainer').css('display', 'none');
            $('#appliedCouponContainer').css('display', 'inline-table');

        }

        var height = $(window).height();
        this.setState({windowHeight: height});

        // window.$('#nav-main').okayNav();


        $('#CheckoutBtn').click(() => {


            var flag = true;
            var productName = "";
            for (var i = 0; i < this.state.productList.length; i++) {

                if (this.state.productList[i].product_modifiers_isOkey == "N") {
                    flag = false;
                    productName = this.state.productList[i].productName;
                    break;
                }
            }


            if (flag) {
                this.fetchStoreSchedule();
            } else {

                this.state.swalButton.fire({
                    title: i18n.t('select_option_inst_2', productName),
                    allowOutsideClick: false
                });

            }


        });


    }


    fetchStoreSchedule() {

        var url = API_ROOT + '/fetchstoreschedule?store_id=' + localStorage.getItem('store_id');
        this.onOpenModal();
        fetch(url)
            .then(response => {
                return response.json();
            })
            .then(storeData => {
                this.onCloseModal();
                var msg = '';
                var heading = "";
                var types = this.state.storeOrderType.split(",");


                // alert(types);
                for (var i = 0; i < types.length; i++) {

                    if (i == 0) {
                        if (types[i] == "P") {
                            heading += i18n.t("pickup");
                        } else if (types[i] == "D") {
                            heading += i18n.t("delivery");
                        } else if (types[i] == "I") {
                            heading += i18n.t("dinein");
                        } else if (types[i] == "C") {
                            heading += i18n.t("curbside");
                        }
                    } else if (i >= 1 && i == types.length - 1) {
                        if (types[i] == "P") {
                            heading += " " + i18n.t("or") + " " + i18n.t("pickup");
                        } else if (types[i] == "D") {
                            heading += " " + i18n.t("or") + " " + i18n.t("delivery");
                        } else if (types[i] == "I") {
                            heading += " " + i18n.t("or") + " " + i18n.t("dinein");
                        } else if (types[i] == "C") {
                            heading += " " + i18n.t("or") + " " + i18n.t("curbside");
                            ;
                        }
                    } else {
                        if (types[i] == "P") {
                            heading += "," + i18n.t("pickup");
                        } else if (types[i] == "D") {
                            heading += "," + i18n.t("delivery");
                        } else if (types[i] == "I") {
                            heading += "," + i18n.t("dinein");
                        } else if (types[i] == "C") {
                            heading += "," + i18n.t("curbside");
                        }
                    }
                }
                if (types.length > 1) {
                    heading += "?";
                }
                var index = types.indexOf('I'); // get index if value found otherwise -1

                if (index > -1) { //if found
                    types.splice(index, 1);
                }

                for (var i = 0; i < types.length; i++) {

                    if (i == 0) {
                        if (i == types.length - 1) {
                            if (types[i] == "P") {
                                if (this.state.storePickupTime != "") {
                                    msg += i18n.t('schedule_for_pickup_in', {time: this.state.storePickupTime});
                                } else {
                                    msg += i18n.t('schedule_for_pickup') + " " + i18n.t('tap_for_reschedule');
                                }
                            } else if (types[i] == "D") {
                                if (this.state.storeDeliveryTime != "") {
                                    msg += i18n.t('schedule_for_pickup_in', {time: this.state.storeDeliveryTime});
                                } else {
                                    msg += i18n.t('schedule_for_delivery') + " " + i18n.t('tap_for_reschedule');
                                }
                            } else if (types[i] == "C") {
                                if (this.state.storePickupTime != "") {
                                    msg += i18n.t('schedule_for_curbside_in', {time: this.state.storePickupTime});
                                } else {
                                    msg += i18n.t('schedule_for_curbside') + " " + i18n.t('tap_for_reschedule');
                                }
                            }
                        } else {
                            if (types[i] == "P") {
                                msg += i18n.t('schedule_for_pickup');
                            } else if (types[i] == "D") {
                                msg += i18n.t('schedule_for_delivery');
                            } else if (types[i] == "C") {
                                msg += i18n.t('schedule_for_curbside');
                            }
                        }

                    } else if (i >= 1 && i == types.length - 1) {
                        if (types[i] == "P") {

                            msg += " " + i18n.t('or') + " " + i18n.t('pickup') + ". " + i18n.t('tap_for_reschedule');

                        } else if (types[i] == "D") {

                            msg += " " + i18n.t('or') + " " + i18n.t('delivery') + ". " + i18n.t('tap_for_reschedule');

                        } else if (types[i] == "C") {

                            msg += " " + i18n.t('or') + " " + i18n.t('curbside') + ". " + i18n.t('tap_for_reschedule');

                        }
                    } else {
                        if (types[i] == "P") {
                            msg += ", " + i18n.t('pickup');
                        } else if (types[i] == "D") {
                            msg += ", " + i18n.t('delivery');
                        } else if (types[i] == "C") {
                            msg += ", " + i18n.t('curbside');
                        }
                    }
                }
                var buttons = "";
                if (this.state.storeOrderType.indexOf("P") > -1) {
                    buttons += '<button type="button" id="btnPickup" class="swal2-confirm link_button" aria-label="" style="display: inline-block;margin: 0px;">' + i18n.t('pickup') + '</button>';
                }
                if (this.state.storeOrderType.indexOf("D") > -1) {
                    buttons += '<button type="button" id="btnDelivery" class="swal2-confirm link_button" aria-label="" style="display: inline-block;margin: 0px;">' + i18n.t('delivery') + '</button>';
                }
                if (this.state.storeOrderType.indexOf("I") > -1) {
                    buttons += '<button type="button" id="btnDinein" class="swal2-confirm link_button" aria-label="" style="display: inline-block;margin: 0px;">' + i18n.t('dinein') + '</button>';
                }
                if (this.state.storeOrderType.indexOf("C") > -1) {
                    buttons += '<button type="button" id="btnCurbside" class="swal2-confirm link_button" aria-label="" style="display: inline-block;margin: 0px;">' + i18n.t('curbside') + '</button>';
                }

                var html = "";
                if (this.state.storeOrderType.indexOf("D") > 1) {

                    var couponApplied = sessionStorage.getItem("couponApplied");

                    var deliveryFee = this.state.storeDeliveryFee;
                    var disc = "";
                    if (couponApplied) {

                        var type = sessionStorage.getItem("couponType");

                        var discount = parseFloat(sessionStorage.getItem("couponDiscount"));

                        if (type == "C") {

                            deliveryFee = deliveryFee - discount;

                            disc = " (" + i18n.t('discount_applied') + ": $" + discount.toFixed(2) + ") ";
                        }
                        if (type == "D") {

                            deliveryFee = (deliveryFee * discount) / 100;
                            disc = " (" + i18n.t('discount_applied') + ": " + discount + "%) ";
                        }

                    }
                    this.setState({storeDeliveryFeeDiscount: deliveryFee});
                    html += '<i>' + i18n.t('delivery_instruction', {delivery: (deliveryFee + disc)}) + '</i>';

                }


                if (this.state.storeWeeklyOrder == "N") {

                    if (storeData.status == 1) {
                        var timeOption = '';
                        var dateOption = '';

                        this.setState({dineInFlag: storeData.dineInFlag});
                        timeOption += '<option value="">' + i18n.t('select_any') + '</option>';
                        if (this.state.dineInFlag == "Y") {
                            timeOption += '<option value="ASAP">ASAP</option>';
                        }


                        for (var i = 0; i < storeData.slots.length; i++) {
                            timeOption += '<option value="' + storeData.slots[i] + '">' + storeData.slots[i] + '</option>';
                        }

                        if (msg == "") {
                            html += '<div class="timing" style="display: none;"><a id="timingClick"> <img class="timer" src="/img/time.png"/><div class="timeContent">' + msg + '</div></a></div>' + dateOption + '<div class="timeSelect"><span><select class="form-control custom-select" id="timeSelect" name="timeSelect">' + timeOption + ' </select></span></div>' + buttons;
                        } else {
                            html += '<div class="timing"><a id="timingClick"> <img class="timer" src="/img/time.png"/><div class="timeContent">' + msg + '</div></a></div>' + dateOption + '<div class="timeSelect"><span><select class="form-control custom-select" id="timeSelect" name="timeSelect">' + timeOption + ' </select></span></div>' + buttons;
                        }
                        this.state.orderTypeDialog.fire({
                            title: heading + ' <img id="btnCloseDialog" class="btnCloseDialog" src="/img/close.png"/>',
                            allowOutsideClick: false,
                            showCloseButton: false,
                            showCancelButton: false,
                            showConfirmButton: false,
                            html: html,

                        });

                        $('#btnCloseDialog').click(() => {

                            this.state.orderTypeDialog.close();

                        });
                        $('#timeSelect').change(() => {

                            if ($('#timeSelect').val() == "") {
                                //    $('#timeSelect').parent().find('.holder').html('Select Any');
                            } else {

                                //  $('#timeSelect').parent().find('.holder').html($('#timeSelect').val());
                            }
                        });
                        if (this.state.dineInFlag == "Y") {
                            $('#timeSelect').val('ASAP');
                            // $('#timeSelect').parent().find('.holder').html($('#timeSelect').val());
                            $('.timeSelect').css('display', 'none');
                            this.setState({timingStatus: 0});
                        } else {
                            //  $('#timeSelect').parent().find('.holder').html("SELECT ANY");
                            $('.timeSelect').css('display', 'inline-block');
                            this.setState({timingStatus: 1});
                        }


                        $('#timingClick').click(() => {

                            if (this.state.timingStatus == 0) {
                                $('.timeSelect').css('display', 'inline-block');
                                $('#btnDinein').css('display', 'none');

                                this.setState({timingStatus: 1});
                            } else {
                                $('.timeSelect').css('display', 'none');
                                $('#btnDinein').css('display', 'inline-block');
                                this.setState({timingStatus: 0});
                            }
                        });
                        $('#btnPickup').click(() => {

                            if (this.toVerifyDelivery("P")) {


                                sessionStorage.setItem("orderType", "P");
                                sessionStorage.setItem("orderDeliveryFee", 0);

                                sessionStorage.setItem("tip", this.state.tip);
                                sessionStorage.setItem("slots", $('#timeSelect').val())
                                sessionStorage.setItem("curbsideDesc", "");
                                sessionStorage.setItem("table", "");
                                sessionStorage.setItem("date", "");

                                if (sessionStorage.getItem('guestFlag') == 'Y') {
                                    this.state.orderTypeDialog.close();
                                    this.setState({guestRedirectFlag: true});
                                } else {

                                    if (sessionStorage.getItem("orderType") == "D") {

                                        this.checkCustomerDistance();
                                    } else {
                                        this.state.orderTypeDialog.close();
                                        this.setState({checkoutRedirectFlag: true});
                                    }
                                }
                            }
                        });
                        $('#btnDelivery').click(() => {

                            if (this.toVerifyDelivery("D")) {

                                sessionStorage.setItem("orderType", "D");
                                sessionStorage.setItem("orderDeliveryFee", this.state.storeDeliveryFeeDiscount);

                                sessionStorage.setItem("tip", this.state.tip);
                                sessionStorage.setItem("slots", $('#timeSelect').val())
                                sessionStorage.setItem("curbsideDesc", "");
                                sessionStorage.setItem("table", "");
                                sessionStorage.setItem("date", "");

                                if (sessionStorage.getItem('guestFlag') == 'Y') {
                                    this.state.orderTypeDialog.close();
                                    this.setState({guestRedirectFlag: true});
                                } else {

                                    if (sessionStorage.getItem("orderType") == "D") {
                                        this.checkCustomerDistance();
                                    } else {
                                        this.state.orderTypeDialog.close();
                                        this.setState({checkoutRedirectFlag: true});
                                    }
                                }
                            }
                        });
                        $('#btnDinein').click(() => {

                            if (this.state.dineInFlag == "Y") {

                                this.state.swalTable.fire({
                                    title: '<span style="width:100%;text-align: center;">' + i18n.t('dinein') + '</span>',
                                    input: 'number',
                                    html: '<h5>' + i18n.t('enter_table_no') + '</h5>',
                                    showCancelButton: true,
                                    confirmButtonText: i18n.t('continue'),
                                    preConfirm: (login) => {

                                        if (login == "") {
                                            this.state.swalTable.showValidationMessage(i18n.t('enter_table_name'));
                                        }

                                    },
                                }).then((result) => {


                                    if (result.dismiss) {
                                        this.fetchStoreSchedule();
                                    } else {


                                        sessionStorage.setItem("orderType", "I");
                                        sessionStorage.setItem("orderDeliveryFee", 0);

                                        sessionStorage.setItem("tip", this.state.tip);
                                        sessionStorage.setItem("slots", "ASAP");
                                        sessionStorage.setItem("table", result.value);
                                        sessionStorage.setItem("curbsideDesc", "");

                                        sessionStorage.setItem("date", "");

                                        if (sessionStorage.getItem('guestFlag') == 'Y') {
                                            this.setState({guestRedirectFlag: true});
                                        } else {


                                            this.setState({checkoutRedirectFlag: true});

                                        }


                                    }

                                });
                            } else {

                                this.state.swalButton.fire({
                                    title: i18n.t('store_close_inst'),
                                    allowOutsideClick: false
                                });
                            }
                        });

                        $('#btnCurbside').click(() => {
                                var time = $('#timeSelect').val();
                                if (this.toVerifyDelivery("C")) {

                                    this.state.swalCurbside.fire({
                                        title: '<span style="width:100%;text-align: center;">' + i18n.t('curbside_information') + '</span>',
                                        input: 'textarea',
                                        html: i18n.t('curbside_inst'),
                                        showCancelButton: true,
                                        confirmButtonText: i18n.t('continue'),
                                        preConfirm: (login) => {

                                            if (login == "") {
                                                this.state.swalCurbside.showValidationMessage(i18n.t('vehicle_info'));
                                            }

                                        },
                                    }).then((result) => {


                                        if (result.dismiss) {
                                            this.fetchStoreSchedule();
                                        } else {


                                            sessionStorage.setItem("orderType", "C");
                                            sessionStorage.setItem("orderDeliveryFee", 0);

                                            sessionStorage.setItem("curbsideDesc", result.value);

                                            sessionStorage.setItem("tip", this.state.tip);
                                            sessionStorage.setItem("slots", time);
                                            sessionStorage.setItem("table", "");
                                            sessionStorage.setItem("date", "");


                                            if (sessionStorage.getItem('guestFlag') == 'Y') {
                                                this.setState({guestRedirectFlag: true});
                                            } else {


                                                this.setState({checkoutRedirectFlag: true});

                                            }


                                        }

                                    });
                                }
                                /*  } else {

                                this.state.swalButton.fire({
                                    title: "Sorry, our store is closed right now. Please place your order during the business hours. Thank you!",
                                    allowOutsideClick: false
                                });
                            } */
                            }
                        );

                    } else {

                        this.state
                            .swalButton
                            .fire({title: storeData.message, allowOutsideClick: false});

                    }


                } else {


                    /***** WEEKLY ORDER ******/
                    if (storeData.status == 1) {


                        //this.state.storeOrderType;


                        this.setState({dineInFlag: storeData.dineInFlag});
                        var dateOption = '';
                        //var msg = '';
                        var timeOption = '<option value="">' + i18n.t('select_any') + '</option>';
                        //alert(storeData.slots.length);
                        if (storeData.slots.length > 0) {

                            if (this.state.dineInFlag == "Y") {


                                timeOption += '<option value="ASAP">ASAP</option>';
                            }
                        }

                        for (var i = 0; i < storeData.slots.length; i++) {
                            timeOption += '<option value="' + storeData.slots[i] + '">' + storeData.slots[i] + '</option>';
                        }


                        for (var i = 0; i < storeData.dates.length; i++) {
                            dateOption += '<option value="' + storeData.dates[i] + '">' + moment(storeData.dates[i], "YYYY-MM-DD").format("MMMM Do YYYY") + '</option>';
                        }

                        dateOption = '<div class="timeSelect"><span  style="margin-bottom: 0px;"><select class="form-control custom-select" id="dateSelect" ><option value="">' + i18n.t('select_any') + '</option>' + dateOption + ' </select></span></div>'

                        if (msg == "") {
                            html += '<div class="timing" style="display: none;"><a id="timingClick"> <img class="timer" src="/img/time.png"/><div class="timeContent">' + msg + '</div></a></div>' + dateOption + '<div class="timeSelect"><span ><select class="form-control custom-select" id="timeSelect" name="timeSelect">' + timeOption + ' </select></span></div>' + buttons;
                        } else {
                            html += '<div class="timing"><a id="timingClick"> <img class="timer" src="/img/time.png"/><div class="timeContent">' + msg + '</div></a></div>' + dateOption + '<div class="timeSelect"><span><select class="form-control custom-select" id="timeSelect" name="timeSelect">' + timeOption + ' </select></span></div>' + buttons;
                        }


                        this.state.orderTypeDialog.fire({
                            title: heading + ' <img id="btnCloseDialog" class="btnCloseDialog" src="/img/close.png"/>',
                            allowOutsideClick: false,
                            showCloseButton: false,
                            showCancelButton: false,
                            showConfirmButton: false,
                            html: html,

                        });


                        if (storeData.slots.length > 0) {


                            if (this.state.dineInFlag == "Y") {
                                $('.timeSelect').css('display', 'none');
                                $('#timeSelect').val('ASAP');
                                this.setState({timingStatus: 1});
                                //  $('#timeSelect').parent().find('.holder').html($('#timeSelect').val());
                            } else {
                                //   $('#timeSelect').parent().find('.holder').html("SELECT ANY");
                                $('.timeSelect').css('display', 'inline-block');
                                this.setState({timingStatus: 0});
                            }

                            //  $('#dateSelect').val(moment().format("YYYY-MM-DD"));
                            $("#dateSelect").val($("#dateSelect option:eq(1)").val());
                            this.fetchTiming();
                            // $('#dateSelect').parent().find('.holder').html(moment($('#dateSelect').val(), "YYYY-MM-DD").format("MMMM Do YYYY"));


                        } else {
                            this.setState({timingStatus: 1});
                            $('.timeSelect').css('display', 'inline-block');
                        }
                        $('#btnCloseDialog').click(() => {

                            this.state.orderTypeDialog.close();

                        });
                        $('#timeSelect').change(() => {

                            if ($('#timeSelect').val() == "") {
                                //    $('#timeSelect').parent().find('.holder').html('Select Any');
                            } else {

                                //  $('#timeSelect').parent().find('.holder').html($('#timeSelect').val());
                            }
                        });
                        $('#dateSelect').change(() => {

                            if ($('#dateSelect').val() == "") {
                                //  $('#dateSelect').parent().find('.holder').html('Select Any');
                            } else {
                                //  $('#dateSelect').parent().find('.holder').html(moment($('#dateSelect').val(), "YYYY-MM-DD").format("MMMM Do YYYY"));
                                this.fetchTiming();
                            }

                        });

                        $('#timingClick').click(() => {

                            if (this.state.timingStatus == 0) {
                                $('.timeSelect').css('display', 'inline-block');
                                $('#btnDinein').css('display', 'none');
                                this.setState({timingStatus: 1});
                            } else {
                                $('.timeSelect').css('display', 'none');
                                $('#btnDinein').css('display', 'inline-block');
                                this.setState({timingStatus: 0});
                            }
                        });


                        $('#btnPickup').click(() => {

                            if (this.toVerifyDelivery("P")) {


                                sessionStorage.setItem("orderType", "P");
                                sessionStorage.setItem("orderDeliveryFee", 0);

                                sessionStorage.setItem("tip", this.state.tip);
                                sessionStorage.setItem("slots", $('#timeSelect').val())
                                sessionStorage.setItem("curbsideDesc", "");
                                sessionStorage.setItem("table", "");
                                sessionStorage.setItem("date", $('#dateSelect').val());

                                if (sessionStorage.getItem('guestFlag') == 'Y') {
                                    this.state.orderTypeDialog.close();
                                    this.setState({guestRedirectFlag: true});
                                } else {

                                    if (sessionStorage.getItem("orderType") == "D") {
                                        this.checkCustomerDistance();
                                    } else {
                                        this.state.orderTypeDialog.close();
                                        this.setState({checkoutRedirectFlag: true});
                                    }
                                }
                            }
                        });
                        $('#btnDelivery').click(() => {

                            if (this.toVerifyDelivery("D")) {

                                sessionStorage.setItem("orderType", "D");
                                sessionStorage.setItem("orderDeliveryFee", this.state.storeDeliveryFeeDiscount);

                                sessionStorage.setItem("tip", this.state.tip);
                                sessionStorage.setItem("slots", $('#timeSelect').val());
                                sessionStorage.setItem("date", $('#dateSelect').val());
                                sessionStorage.setItem("curbsideDesc", "");
                                sessionStorage.setItem("table", "");


                                if (sessionStorage.getItem('guestFlag') == 'Y') {
                                    this.state.orderTypeDialog.close();
                                    this.setState({guestRedirectFlag: true});

                                } else {

                                    if (sessionStorage.getItem("orderType") == "D") {
                                        this.checkCustomerDistance();
                                    } else {
                                        this.state.orderTypeDialog.close();
                                        this.setState({checkoutRedirectFlag: true});
                                    }
                                }
                            }
                        });
                        $('#btnDinein').click(() => {

                            if (this.state.dineInFlag == "Y") {

                                if (this.toVerifyDelivery("I")) {
                                    this.state.swalTable.fire({
                                        title: '<span style="width:100%;text-align: center;">' + i18n.t('dinein') + '</span>',
                                        input: 'number',
                                        html: '<h5>' + i18n.t('enter_table_no') + '</h5>',
                                        showCancelButton: true,
                                        confirmButtonText: i18n.t('continue'),
                                        preConfirm: (login) => {

                                            if (login == "") {
                                                this.state.swalTable.showValidationMessage(i18n.t('enter_table_no'));
                                            }

                                        },
                                    }).then((result) => {


                                        if (result.dismiss) {
                                            this.fetchStoreSchedule();
                                        } else {


                                            sessionStorage.setItem("orderType", "I");
                                            sessionStorage.setItem("orderDeliveryFee", 0);

                                            sessionStorage.setItem("tip", this.state.tip);
                                            sessionStorage.setItem("slots", "ASAP");
                                            sessionStorage.setItem("table", result.value);
                                            sessionStorage.setItem("curbsideDesc", "");

                                            sessionStorage.setItem("date", "");

                                            if (sessionStorage.getItem('guestFlag') == 'Y') {
                                                this.setState({guestRedirectFlag: true});
                                            } else {


                                                this.setState({checkoutRedirectFlag: true});

                                            }


                                        }

                                    });
                                }
                            } else {

                                this.state.swalButton.fire({
                                    title: i18n.t('store_close_inst'),
                                    allowOutsideClick: false
                                });
                            }
                        });
                        $('#btnCurbside').click(() => {

                                var time = $('#timeSelect').val();
                                var date = $('#dateSelect').val();

                                if (this.toVerifyDelivery("C")) {

                                    this.state.swalCurbside.fire({
                                        title: '<span style="width:100%;text-align: center;">CURBSIDE INFORMATION</span>',
                                        input: 'textarea',
                                        html: i18n.t('curbside_inst'),
                                        showCancelButton: true,
                                        confirmButtonText: i18n.t('continue'),
                                        preConfirm: (login) => {

                                            if (login == "") {
                                                this.state.swalCurbside.showValidationMessage(i18n.t('vehicle_info'));
                                            }

                                        },
                                    }).then((result) => {


                                        if (result.dismiss) {
                                            this.fetchStoreSchedule();
                                        } else {


                                            sessionStorage.setItem("orderType", "C");
                                            sessionStorage.setItem("orderDeliveryFee", 0);

                                            sessionStorage.setItem("curbsideDesc", result.value);

                                            sessionStorage.setItem("tip", this.state.tip);
                                            sessionStorage.setItem("slots", time)
                                            sessionStorage.setItem("table", "");
                                            sessionStorage.setItem("date", date);


                                            if (sessionStorage.getItem('guestFlag') == 'Y') {
                                                this.setState({guestRedirectFlag: true});
                                            } else {


                                                this.setState({checkoutRedirectFlag: true});

                                            }


                                        }

                                    });
                                }
                                /*  } else {

                                this.state.swalButton.fire({
                                    title: "Sorry, our store is closed right now. Please place your order during the business hours. Thank you!",
                                    allowOutsideClick: false
                                });
                            } */
                            }
                        )
                        ;

                    } else {

                        this.state
                            .swalButton
                            .fire({title: storeData.message, allowOutsideClick: false});

                    }


                }


            })
        ;
    }



    fetchTiming() {


        var url = API_ROOT + '/fetchstoretiming?store_id=' + localStorage.getItem('store_id') + "&date=" + $('#dateSelect').val();
        this.onOpenModal();
        fetch(url)
            .then(response => {
                return response.json();
            })
            .then(storeData => {
                this.onCloseModal();


                if (storeData.status == 1) {
                    var timeOption = '<option value="">Select Any</option>';
                    if ($('#dateSelect').val() == moment().format("YYYY-MM-DD") && storeData.slots.length > 0) {
                        if (storeData.dineInFlag == "Y") {
                            timeOption += '<option value="ASAP">ASAP</option>';
                        }
                    }


                    for (var i = 0; i < storeData.slots.length; i++) {
                        timeOption += '<option value="' + storeData.slots[i] + '">' + storeData.slots[i] + '</option>';
                    }


                    $('#timeSelect').html(timeOption);
                    if ($('#dateSelect').val() == moment().format("YYYY-MM-DD") && storeData.slots.length > 0) {
                        if (storeData.dineInFlag == "Y") {

                            $('#timeSelect').val("ASAP");
                            //   $('#timeSelect').parent().find('.holder').html($('#timeSelect').val());
                        } else {
                            //   $('#timeSelect').parent().find('.holder').html("Select Any");
                        }
                    }

                } else {
                    this.state.swalButton.fire({title: storeData.message, allowOutsideClick: false});
                }
            });

    };

    checkCustomerDistance() {

        var dbconn = new db();
        this.onOpenModal();

        dbconn.getAll().then(data => {

            if (!data || data.length < 1 || sessionStorage.getItem('guestFlag') == 'Y') {
                this.setState({nosessionredirect: true});
            } else {

                if (parseInt(localStorage.getItem("store_delivery_range")) > 0 && localStorage.getItem('store_latitude') != "" && localStorage.getItem('store_longitude') != "") {
                    var address = "";
                    if (data[0].customer_addreess != "") {
                        address = data[0].customer_address;
                    }
                    if (data[0].customer_city != "") {
                        address += ", " + data[0].customer_city;
                    }
                    if (data[0].customer_state != "") {
                        address += ", " + data[0].customer_state;
                    }
                    if (data[0].customer_zipcode != "") {
                        address += ", " + data[0].customer_zipcode;
                    }
                    var url = API_ROOT + '/fetchdistance';

                    var options = {
                        address: address,
                        latitude: localStorage.getItem("store_latitude"),
                        longitude: localStorage.getItem("store_longitude"),
                        distance: localStorage.getItem("store_delivery_range"),
                    };

                    axios.post(url, options).then(response => {

                        this.onCloseModal();

                        if (response.data.status == 1) {
                            this.state.orderTypeDialog.close();
                            this.setState({checkoutRedirectFlag: true});
                        } else {

                            this.state.swalButton.fire({
                                title: response.data.message,
                                allowOutsideClick: false
                            });
                        }
                    }).catch(function (error) {
                        this.onCloseModal();
                        console.log(error);
                    });


                } else {
                    this.onCloseModal()
                    this.setState({checkoutRedirectFlag: true});
                }
            }
        });
    }
    toVerifyDelivery(type) {

        var flag = true;

        if (type != "I") {
            if (this.state.storeWeeklyOrder == "N") {

                if ($('#timeSelect').val() == "") {

                    alert(i18n.t('time_slot_inst'));
                    return false;

                }
            } else {
                if ($('#dateSelect').val() == "") {

                    alert(i18n.t('date_inst'));

                    return false;

                }
                if ($('#timeSelect').val() == "") {

                    alert(i18n.t('time_slot_inst'));
                    return false;

                }
            }
        }

        var couponApplied = sessionStorage.getItem("couponApplied");

        if (couponApplied) {

            var deliveryType = sessionStorage.getItem("couponDeliveryType");

            if (deliveryType.indexOf(type) < 0) {
                if (type == "P") {
                    alert(i18n.t('coupon_invalid', {type: i18n.t('pickup')}));
                    return false;
                } else if (type == "D") {
                    alert(i18n.t('coupon_invalid', {type: i18n.t('delivery')}));
                    return false;
                } else if (type == "C") {
                    alert(i18n.t('coupon_invalid', {type: i18n.t('curbside')}));
                    return false;
                } else if (type == "I") {
                    alert(i18n.t('coupon_invalid', {type: i18n.t('dinein')}));
                    return false;
                }
            }


        }

        return flag;
    }

    calculateTax(isCouponLoad) {
        var taxArray = this.state.tax;

        var totalTax = 0;

        for (var i = 0; i < taxArray.length; i++) {

            var tax = ((parseFloat(this.state.cartTotal) * parseFloat(taxArray[i].tax_percentage)) / 100);


            taxArray[i].tax_value = tax.toFixed(2);

            totalTax += tax;
        }

        this.setState({tax: taxArray});
        this.setState({finalTax: totalTax.toFixed(2)});

        this.calculateTip(isCouponLoad);

    }

    plusQuantity = (item) => {

        var product_id = item.product_id
        var product_price = (parseFloat(item.product_price) + parseFloat(item.mod_price));
        var cart_id = item.cart_id;

        var currentVal = parseInt($('#quant_' + cart_id).val());
        var newVal = 0;
        var newPrice = 0;
        var cartTotal = parseFloat(this.state.cartTotal);
        var newCartTotal = 0;

        var couponType = sessionStorage.getItem("couponType");

        var couponDiscount = 0;

        if (couponType && (couponType == "E" || couponType == "J" || couponType == "K")) {


            couponDiscount = item.product_discount;
            couponType = item.product_discount_type;

        } else {
            couponType = "";
        }


        var dbconn = new db();

        if (!isNaN(currentVal)) {

            if (currentVal < $('#quant_' + cart_id).attr('max')) {
                newVal = currentVal + 1;
                var discount = 0;

                if (couponType == "P") {
                    discount = ((parseFloat(product_price) * couponDiscount) / 100);
                } else if (couponType == "A") {

                    discount = couponDiscount;
                }


                newPrice = ((parseFloat(product_price) - discount) * newVal).toFixed(2);
                // newCartTotal = (cartTotal + parseFloat(product_price)).toFixed(2);
                $('#quant_' + cart_id).val(newVal);
                $('#product_price_' + cart_id).html(newPrice);
                //  sessionStorage.setItem('cartTotal', newCartTotal.toString());
                //  this.setState({cartTotal: newCartTotal});

                dbconn.getAllOrder().then(productData => {

                    productData.map((item, index) => {


                        if (parseInt(item.cart_id) == parseInt(cart_id)) {


                            dbconn.deleteOrder(parseInt(cart_id)).then(data => {

                                dbconn.setOrder({
                                    product_name: item.product_name,
                                    product_desc: item.product_desc,
                                    product_name_es: item.product_name_es,
                                    product_desc_es: item.product_desc_es,
                                    product_id: item.product_id,
                                    product_img: item.product_img,
                                    product_quantity: newVal,
                                    product_notes: item.product_notes,
                                    product_original_price: item.product_original_price,
                                    product_price: item.product_price,
                                    product_discount: item.product_discount,
                                    product_discount_type: item.product_discount_type,
                                    product_modifiers: item.product_modifiers,
                                    product_loyalty_enabled: item.product_loyalty_enabled,
                                    product_loyalty_price: item.product_loyalty_price,
                                    mod_price: item.mod_price,
                                    mod_original_price: item.mod_original_price,
                                    isModifierAvailable: item.isModifierAvailable,
                                    cart_id: cart_id
                                }, cart_id).then(data => {
                                    //this.calculateTax(true);
                                    this.calculateCartTotal(true);
                                });
                            });
                        }
                    });

                });
            } else if (parseInt($('#quant_' + cart_id).val()) == $('#quant_' + cart_id).attr('max')) {
                $('#btn-plus_' + cart_id).attr('disabled', true);
            }
        } else {
            $('#quant_' + cart_id).val(0);
        }

    };

    calculateCartTotal = (isCouponLoad) => {

        var dbconn = new db();

        var cartTotal = 0;

        dbconn.getAllOrder().then(products => {

            products.map((item, index) => {

                if (item.product_loyalty_enabled == "N") {

                    var discount = 0;
                    if (item.product_discount_type == "P" || item.product_discount_type == "H" || item.product_discount_type == "G") {

                        discount = ((parseFloat(item.product_price) + parseFloat(item.mod_price)) * parseFloat(item.product_discount)) / 100;

                    } else if (item.product_discount_type == "A") {
                        discount = parseFloat(item.product_discount);
                    }


                    cartTotal += (((parseFloat(item.product_price) + parseFloat(item.mod_price)) - discount) * parseInt(item.product_quantity));

                } else {
                    cartTotal += (parseFloat(item.mod_price) * parseInt(item.product_quantity));
                }
            });

            sessionStorage.setItem('cartTotal', cartTotal);
            this.setState({cartTotal: cartTotal});
            this.calculateTax(isCouponLoad);
        });
    };
    lessQuantity = (item) => {

        var product_id = item.product_id
        var product_price = (parseFloat(item.product_price) + parseFloat(item.mod_price));
        var cart_id = item.cart_id;


        var currentVal = parseInt($('#quant_' + cart_id).val(), 10);
        var newVal = 0;
        var newPrice = 0;
        var cartTotal = parseFloat(this.state.cartTotal);
        var newCartTotal = 0;
        var couponDiscount = 0;
        var couponType = sessionStorage.getItem("couponType");

        if (couponType && (couponType == "E" || couponType == "J" || couponType == "K")) {


            couponDiscount = item.product_discount;
            couponType = item.product_discount_type;

        } else {
            couponType = "";
        }

        var dbconn = new db();

        if (!isNaN(currentVal)) {
            if (currentVal > $('#quant_' + cart_id).attr('min')) {

                newVal = currentVal - 1;


                var discount = 0;

                if (couponType == "P") {
                    discount = ((parseFloat(product_price) * couponDiscount) / 100);
                } else if (couponType == "A") {

                    discount = couponDiscount;
                }
                newPrice = ((parseFloat(product_price) - discount) * newVal).toFixed(2);

                //  newCartTotal = (cartTotal - parseFloat(product_price)).toFixed(2);

                $('#quant_' + cart_id).val(newVal).change();
                $('#product_price_' + cart_id).html(newPrice);
                //  sessionStorage.setItem('cartTotal', newCartTotal.toString());
                //  this.setState({cartTotal: newCartTotal});

                dbconn.getAllOrder().then(productData => {

                    productData.map((item, index) => {

                        if (item.cart_id == cart_id) {
                            dbconn.deleteOrder(parseInt(cart_id)).then(data => {
                                dbconn.setOrder({
                                    product_name: item.product_name,
                                    product_desc: item.product_desc,
                                    product_name_es: item.product_name_es,
                                    product_desc_es: item.product_desc_es,
                                    product_id: item.product_id,
                                    product_img: item.product_img,
                                    product_quantity: newVal,
                                    product_notes: item.product_notes,
                                    product_price: item.product_price,
                                    product_original_price: item.product_original_price,
                                    product_discount: item.product_discount,
                                    product_discount_type: item.product_discount_type,
                                    product_loyalty_enabled: item.product_loyalty_enabled,
                                    product_loyalty_price: item.product_loyalty_price,
                                    product_modifiers: item.product_modifiers,
                                    isModifierAvailable: item.isModifierAvailable,
                                    mod_price: item.mod_price,
                                    mod_original_price: item.mod_original_price,
                                    cart_id: cart_id
                                }, cart_id).then(data => {
                                    //this.calculateTax(true);
                                    this.calculateCartTotal(true);
                                });
                            });
                        }
                    });

                });

            }
            if (parseInt($('#quant_' + cart_id).val(), 10) == $('#quant_' + cart_id).attr('min')) {
                $('#btn-minus_' + cart_id).attr('disabled', true);
            }
        } else {
            $('#quant_' + cart_id).val(0);
        }

    };

    handleKeyUp = e => {

        if ($(e.target).val() != "") {

            this.setState({tipSelected: "other"});
            this.setState({tip: parseFloat($(e.target).val()).toFixed(2)});


        } else {
            this.setState({tip: 0});
        }

    };

    calculateTip = (isCouponLoad) => {


        if (this.state.customTipVisible == "none") {
            var tips = ((parseFloat(this.state.cartTotal) * parseFloat(this.state.tipSelected)) / 100);

            this.setState({tip: tips.toFixed(2)});
            console.log("TIPSELECTED " + this.state.tipSelected);
        }

        if (isCouponLoad) {
            this.calculateCoupon();
        }


    };

    calculateCoupon = () => {
        var couponApplied = sessionStorage.getItem("couponApplied");


        if (couponApplied) {


            var type = sessionStorage.getItem("couponType");
            var minSubTotal = parseFloat(sessionStorage.getItem("couponMinSubtotal"));


            this.setState({couponApplied: "Y"});
            this.setState({couponType: type});

            this.setState({couponMinSubtotal: minSubTotal});

            console.log("A " + (this.state.cartTotal < minSubTotal));
            if (type == "A" || type == "B" || type == "C" || type == "D" || type == "E" || type == "F" || type == "G" || type == "H" || type == "I" || type == "J" || type == "K") {


                if (this.state.cartTotal < minSubTotal) {

                    this.state
                        .swalButton
                        .fire({
                            title: i18n.t('coupon_amount_invalid') + minSubTotal.toFixed(2),
                            allowOutsideClick: false
                        });


                    this.cancelCoupon();
                } else {

                    if (type == "A") {
                        let myColor = {background: '#0E1717', text: "#FFFFFF"};
                        notify.show(i18n.t('coupon_success'), "custom", 2000, myColor);
                        this.setState({couponDiscount: parseFloat(sessionStorage.getItem("couponDiscount"))});

                    }
                    if (type == "B") {
                        let myColor = {background: '#0E1717', text: "#FFFFFF"};
                        notify.show(i18n.t('coupon_success'), "custom", 2000, myColor);
                        var discount = parseFloat(sessionStorage.getItem("couponDiscount"));
                        discount = (parseFloat(this.state.cartTotal) * discount) / 100;
                        this.setState({couponDiscount: discount});
                    }

                    if (type == "E") {


                        var dbconn = new db();
                        dbconn.getAllOrder().then(productData => {

                            console.log(productData);

                            var products = JSON.parse(sessionStorage.getItem("couponProductDetails"));
                            console.log(products);
                            var productMatchCounter = 0;
                            var productArray = [];
                            for (var i = 0; i < productData.length; i++) {
                                productArray = [];

                                for (var j = 0; j < products.length; j++) {

                                    productArray.push(products[j].product_name);

                                    if (productData[i].product_id == products[j].product_id && productData[i].product_loyalty_enabled == "N" && products[j].coupon_details_type == "Q") {

                                        productMatchCounter++;

                                    }


                                }

                            }


                            if (productMatchCounter == products.length) {

                                let myColor = {background: '#0E1717', text: "#FFFFFF"};
                                notify.show(i18n.t('coupon_success'), "custom", 2000, myColor);

                                //this.calculateTax(false);

                                var dbconn = new db();
                                dbconn.getAllOrder().then(productData => {

                                    var totalLoyalty = 0;


                                    var i = 0;
                                    productData.forEach(function (product) {

                                        if (product.product_loyalty_enabled == "Y") {
                                            totalLoyalty += parseInt(product.product_loyalty_price);
                                        }


                                        for (var j = 0; j < products.length; j++) {


                                            if (product.product_id == products[j].product_id && product.product_loyalty_enabled == "N" && products[j].coupon_details_type == "Q") {


                                                // dbconn.deleteOrder(parseInt(productData[i].cart_id)).then(data => {


                                                productData[i].product_discount = sessionStorage.getItem("couponDiscount");
                                                productData[i].productt_discount_type = "P";
                                                console.log(JSON.stringify({
                                                    product_name: product.product_name,
                                                    product_desc: product.product_desc,
                                                    product_name_es: product.product_name_es,
                                                    product_desc_es: product.product_desc_es,
                                                    product_id: product.product_id,
                                                    product_img: product.product_img,
                                                    product_quantity: product.product_quantity,
                                                    product_notes: product.product_notes,
                                                    product_price: product.product_price,
                                                    product_discount: sessionStorage.getItem("couponDiscount"),
                                                    product_discount_type: "P",
                                                    product_modifiers: product.product_modifiers,
                                                    product_loyalty_enabled: product.product_loyalty_enabled,
                                                    product_loyalty_price: product.product_loyalty_price,
                                                    mod_price: product.mod_price,
                                                    mod_original_price: product.mod_original_price,
                                                    isModifierAvailable: product.isModifierAvailable,
                                                    cart_id: product.cart_id
                                                }));
                                                var dbconn = new db();
                                                dbconn.setOrder({
                                                    product_name: product.product_name,
                                                    product_desc: product.product_desc,
                                                    product_name_es: product.product_name_es,
                                                    product_desc_es: product.product_desc_es,
                                                    product_id: product.product_id,
                                                    product_img: product.product_img,
                                                    product_quantity: product.product_quantity,
                                                    product_notes: product.product_notes,
                                                    product_price: product.product_price,
                                                    product_original_price: product.product_original_price,
                                                    product_discount: sessionStorage.getItem("couponDiscount"),
                                                    product_discount_type: "P",
                                                    product_modifiers: product.product_modifiers,
                                                    product_loyalty_enabled: product.product_loyalty_enabled,
                                                    product_loyalty_price: product.product_loyalty_price,
                                                    mod_price: product.mod_price,
                                                    mod_original_price: product.mod_original_price,
                                                    isModifierAvailable: product.isModifierAvailable,
                                                    cart_id: product.cart_id
                                                }, product.cart_id).then(data => {

                                                });
                                                // });
                                                //  productMatch = true;
                                                //break;
                                            }


                                        }

                                        i++;
                                    });


                                    this.setState({totalLoyaltyPoints: totalLoyalty});
                                    this.calculateModifiers(productData);
                                    //this.setState({productList: productData});
                                    this.calculateCartTotal(false);

                                });


                            } else {

                                this.state
                                    .swalButton
                                    .fire({
                                        title: i18n.t('coupon_item_invalid') + " " + productArray.join(","),
                                        allowOutsideClick: false
                                    });
                                this.cancelCoupon();


                            }

                        });

                    }
                    if (type == "I" || type == "F") {

                        var dbconn = new db();
                        dbconn.getAllOrder().then(productData => {

                            console.log(productData);

                            var products = JSON.parse(sessionStorage.getItem("couponProductDetails"));
                            console.log(products);
                            var productMatchCounter = 0;
                            var productArray = [];
                            for (var i = 0; i < productData.length; i++) {
                                productArray = [];

                                for (var j = 0; j < products.length; j++) {

                                    productArray.push(products[j].product_name);

                                    if (productData[i].product_id == products[j].product_id && productData[i].product_loyalty_enabled == "N" && products[j].coupon_details_type == "Q") {

                                        productMatchCounter++;

                                    }


                                }

                            }


                            if (productMatchCounter == products.length) {

                                let myColor = {background: '#0E1717', text: "#FFFFFF"};
                                notify.show(i18n.t('coupon_success'), "custom", 2000, myColor);
                                if (type == "F") {
                                    var discount = parseFloat(sessionStorage.getItem("couponDiscount"));
                                    discount = (parseFloat(this.state.cartTotal) * discount) / 100;
                                    this.setState({couponDiscount: discount});
                                } else {

                                    this.setState({couponDiscount: parseFloat(sessionStorage.getItem("couponDiscount"))});

                                }


                            } else {

                                this.state
                                    .swalButton
                                    .fire({
                                        title: i18n.t('coupon_item_invalid') + " " + productArray.join(","),
                                        allowOutsideClick: false
                                    });
                                this.cancelCoupon();


                            }

                        });


                    }

                    if (type == "J" || type == "K") {


                        var dbconn = new db();
                        dbconn.getAllOrder().then(productData => {

                            console.log(productData);
                            var products = JSON.parse(sessionStorage.getItem("couponProductDetails"));
                            console.log(products);
                            var productMatchCounter = 0;
                            var productArray = [];
                            for (var i = 0; i < productData.length; i++) {
                                productArray = [];

                                for (var j = 0; j < products.length; j++) {

                                    productArray.push(products[j].product_name);

                                    if (productData[i].product_id == products[j].product_id && productData[i].product_loyalty_enabled == "N" && products[j].coupon_details_type == "Q") {

                                        productMatchCounter++;

                                    }


                                }

                            }


                            if (productMatchCounter == products.length) {

                                var discountType = "";
                                if (type == "J") {
                                    discountType = "A";
                                } else {
                                    discountType = "P";
                                }

                                let myColor = {background: '#0E1717', text: "#FFFFFF"};
                                notify.show(i18n.t('coupon_success'), "custom", 2000, myColor);

                                //this.calculateTax(false);

                                var dbconn = new db();
                                dbconn.getAllOrder().then(productData => {

                                    var totalLoyalty = 0;
                                    var i = 0;
                                    productData.forEach(function (product) {

                                        if (product.product_loyalty_enabled == "Y") {
                                            totalLoyalty += parseInt(product.product_loyalty_price);
                                        }

                                        for (var j = 0; j < products.length; j++) {


                                            if (product.product_id == products[j].product_id && product.product_loyalty_enabled == "N" && products[j].coupon_details_type == "Q") {


                                                productData[i].product_discount = sessionStorage.getItem("couponDiscount");
                                                productData[i].product_discount_type = discountType;
                                                var dbconn = new db();
                                                dbconn.setOrder({
                                                    product_name: product.product_name,
                                                    product_desc: product.product_desc,
                                                    product_name_es: product.product_name_es,
                                                    product_desc_es: product.product_desc_es,
                                                    product_id: product.product_id,
                                                    product_img: product.product_img,
                                                    product_quantity: product.product_quantity,
                                                    product_notes: product.product_notes,
                                                    product_price: product.product_price,
                                                    product_original_price: product.product_original_price,
                                                    product_discount: sessionStorage.getItem("couponDiscount"),
                                                    product_discount_type: discountType,
                                                    product_modifiers: product.product_modifiers,
                                                    product_loyalty_enabled: product.product_loyalty_enabled,
                                                    product_loyalty_price: product.product_loyalty_price,
                                                    mod_price: product.mod_price,
                                                    mod_original_price: product.mod_original_price,
                                                    isModifierAvailable: product.isModifierAvailable,
                                                    cart_id: product.cart_id
                                                }, product.cart_id).then(data => {

                                                });
                                            }


                                        }
                                        i++;
                                    });

                                    this.setState({totalLoyaltyPoints: totalLoyalty});

                                    this.calculateModifiers(productData);
                                    //this.setState({productList: productData});
                                    this.calculateCartTotal(false);

                                });


                            } else {

                                this.state
                                    .swalButton
                                    .fire({
                                        title: i18n.t('coupon_item_invalid') + " " + productArray.join(","),
                                        allowOutsideClick: false
                                    });
                                this.cancelCoupon();


                            }

                        });

                    }


                    if (type == "H") {

                        var dbconn = new db();

                        dbconn.deleteAllCouponOrder("H").then(db1 => {


                            dbconn.getAllOrder().then(productData => {

                                    console.log(productData);

                                    var products = JSON.parse(sessionStorage.getItem("couponProductDetails"));
                                    console.log(products);
                                    var productMatchCounter = 0;
                                    var productArray = [];
                                    for (var j = 0; j < products.length; j++) {

                                        var flag = false;
                                        for (var i = 0; i < productData.length; i++) {


                                            if (productData[i].product_id == products[j].product_id && productData[i].product_loyalty_enabled == "N" && productData[i].product_discount_type != "H" && products[j].coupon_details_type == "Q") {

                                                flag = true;

                                            }


                                        }

                                        if (flag) {
                                            productMatchCounter++;
                                        }

                                        productArray.push(products[j].product_name);
                                    }


                                    console.log(productMatchCounter + " A " + products.length);

                                    if (productMatchCounter == products.length) {

                                        //   let myColor = {background: '#0E1717', text: "#FFFFFF"};
                                        //   notify.show("Coupon added successfully.", "custom", 2000, myColor);


                                        dbconn.getAllKeys().then(keys => {

                                            var cartLength = 0;
                                            if (keys.length == 0) {
                                                cartLength = 0;
                                            } else {
                                                cartLength = Math.max(...keys);
                                            }

                                            var products = JSON.parse(sessionStorage.getItem("couponProductDetails"));
                                            console.log(products);

                                            var productArray = JSON.parse(JSON.stringify(productData));
                                            for (var i = 0; i < productData.length; i++) {

                                                for (var j = 0; j < products.length; j++) {


                                                    if (productData[i].product_id == products[j].product_id && productData[i].product_loyalty_enabled == "N" && products[j].coupon_details_type == "Q") {

                                                        cartLength++;
                                                        productData[i].product_discount = sessionStorage.getItem("couponDiscount");
                                                        productData[i].product_discount_type = "H";
                                                        productData[i].cart_id = cartLength;

                                                        productArray.push(productData[i]);
                                                        var dbconn = new db();
                                                        dbconn.setOrder(productData[i], cartLength).then(data => {

                                                        });


                                                    }


                                                }

                                            }

                                            console.log(JSON.parse(JSON.stringify(productArray)));

                                            this.calculateModifiers(productArray);
                                            //this.setState({productList: productArray});
                                            this.calculateCartTotal(false);
                                        });


                                        // this.setState({couponDiscount: parseFloat(sessionStorage.getItem("couponDiscount"))});


                                    } else {

                                        this.state
                                            .swalButton
                                            .fire({
                                                title: i18n.t('coupon_item_invalid') + " " + productArray.join(","),
                                                allowOutsideClick: false
                                            });
                                        this.cancelCoupon();


                                    }


                                }
                            );
                        });


                    }
                    if (type == "G") {

                        if (this.state.deleteG) {
                            var dbconn = new db();

                            this.setState({deleteG: false});
                            dbconn.deleteAllCouponOrder("G").then(db1 => {


                                dbconn.getAllOrder().then(productData => {

                                        console.log(productData);

                                        var products = JSON.parse(sessionStorage.getItem("couponProductDetails"));
                                        console.log(products);
                                        var productMatchCounter = 0;
                                        var productArray = [];
                                        for (var j = 0; j < products.length; j++) {

                                            var flag = false;
                                            for (var i = 0; i < productData.length; i++) {


                                                if (productData[i].product_id == products[j].product_id && productData[i].product_loyalty_enabled == "N" && productData[i].product_discount_type != "H" && products[j].coupon_details_type == "Q") {

                                                    flag = true;

                                                }


                                            }

                                            if (flag) {
                                                productMatchCounter++;
                                            }

                                            productArray.push(products[j].product_name);
                                        }


                                        console.log(productMatchCounter + " A " + products.length);

                                        if (productMatchCounter == products.length) {

                                            //   let myColor = {background: '#0E1717', text: "#FFFFFF"};
                                            //   notify.show("Coupon added successfully.", "custom", 2000, myColor);


                                            dbconn.getAllKeys().then(keys => {

                                                var cartLength = 0;
                                                if (keys.length == 0) {
                                                    cartLength = 0;
                                                } else {
                                                    cartLength = Math.max(...keys);
                                                }

                                                var products = JSON.parse(sessionStorage.getItem("couponDiscountedProductDetails"));


                                                for (var j = 0; j < products.length; j++) {


                                                    cartLength++;

                                                    var prod = {
                                                        product_name: products[j].product_name,
                                                        product_desc: products[j].product_description,
                                                        product_name_es: products[j].product_name_es,
                                                        product_desc_es: products[j].product_desc_es,
                                                        product_id: products[j].product_id,
                                                        product_img: products[j].product_image,
                                                        product_quantity: 1,
                                                        product_notes: "",
                                                        product_price: products[j].product_price,
                                                        product_discount: sessionStorage.getItem("couponDiscount"),
                                                        product_discount_type: "G",
                                                        product_modifiers: products[j].product_modifiers,
                                                        product_loyalty_enabled: products[j].product_loyalty_enabled,
                                                        product_loyalty_price: products[j].product_loyalty_price,
                                                        mod_price: 0,
                                                        product_mod_price: 0,
                                                        isModifierAvailable: (products[j].product_modifiers.length > 0 || products[j].product_notes_enabled == "Y") ? true : false,
                                                        cart_id: cartLength
                                                    };

                                                    productData.push(prod);

                                                    var dbconn = new db();
                                                    dbconn.setOrder(prod, cartLength).then(data => {

                                                    });


                                                }


                                                console.log(JSON.parse(JSON.stringify(productData)));
                                                this.calculateModifiers(productData);
                                                //this.setState({productList: productData});
                                                this.calculateCartTotal(false);
                                            });


                                        } else {

                                            this.state
                                                .swalButton
                                                .fire({
                                                    title: i18n.t('coupon_item_invalid') + " " + productArray.join(","),
                                                    allowOutsideClick: false
                                                });
                                            this.cancelCoupon();


                                        }
                                    }
                                );

                            });

                        } else {

                            var dbconn = new db();


                            dbconn.getAllOrder().then(productData => {

                                    console.log(productData);

                                    var products = JSON.parse(sessionStorage.getItem("couponProductDetails"));
                                    console.log(products);
                                    var productMatchCounter = 0;
                                    var productArray = [];
                                    for (var j = 0; j < products.length; j++) {

                                        var flag = false;
                                        for (var i = 0; i < productData.length; i++) {


                                            if (productData[i].product_id == products[j].product_id && productData[i].product_loyalty_enabled == "N" && productData[i].product_discount_type != "H" && products[j].coupon_details_type == "Q") {

                                                flag = true;

                                            }


                                        }

                                        if (flag) {
                                            productMatchCounter++;
                                        }

                                        productArray.push(products[j].product_name);
                                    }


                                    console.log(productMatchCounter + " A " + products.length);

                                    if (productMatchCounter == products.length) {

                                        //   let myColor = {background: '#0E1717', text: "#FFFFFF"};
                                        //   notify.show("Coupon added successfully.", "custom", 2000, myColor);


                                    } else {

                                        this.state
                                            .swalButton
                                            .fire({
                                                title: i18n.t('coupon_item_invalid') + " " + productArray.join(","),
                                                allowOutsideClick: false
                                            });
                                        this.cancelCoupon();


                                    }
                                }
                            );


                        }


                    }
                }
            }
        } else {
            var dbconn = new db();
            dbconn.getAllOrder().then(productData => {
                this.calculateModifiers(productData);
            });
        }

    };

    calculateModifiers = (productData) => {

        for (var i = 0; i < productData.length; i++) {

            var productMod = productData[i].product_modifiers;

            productData[i].product_modifiers_isOkey = "Y";

            if (productData[i].product_discount_type == "G") {
                var modifiers = [];

                for (var j = 0; j < productData[i].product_modifiers.length; j++) {

                    var mod_id = productData[i].product_modifiers[j].mod_id;
                    var mod_required = productData[i].product_modifiers[j].mod_required;

                    var flag = true;
                    for (var k = 0; k < modifiers.length; k++) {
                        if (modifiers[k].mod_id == mod_id) {
                            flag = false;
                        }
                    }

                    if (flag) {
                        modifiers.push({mod_id: mod_id, mod_required: mod_required, mod_option: []});
                    }


                }


                for (var j = 0; j < modifiers.length; j++) {

                    for (var k = 0; k < productData[i].product_modifiers.length; k++) {

                        if (modifiers[j].mod_id == productData[i].product_modifiers[k].mod_id) {

                            modifiers[j].mod_option.push(productData[i].product_modifiers[k].mod_selected);
                        }
                    }
                }
                console.log(modifiers);


                for (var j = 0; j < modifiers.length; j++) {


                    if (modifiers[j].mod_required == "Y") {

                        var flag = 0;
                        for (var k = 0; k < modifiers[j].mod_option.length; k++) {
                            if (modifiers[j].mod_required == "Y" && modifiers[j].mod_option[k] == "Y") {

                                flag = 1;
                            }
                        }

                        if (flag == 0) {
                            productData[i].product_modifiers_isOkey = "N";

                            break;
                        }
                    } else {

                    }


                }


            }


        }


        this.setState({productList: productData});
    };

    updateTip = e => {

        if ($(e.target).val() == "other") {
            this.setState({tip1Visible: "none"});
            this.setState({tip2Visible: "none"});
            this.setState({tip3Visible: "none"});
            this.setState({noTipVisible: "none"});
            this.setState({customTipVisible: "inline-block"});
            this.setState({tipSelected: "other"});
        } else {

            if (this.state.tip1 == 0) {
                this.setState({tip1Visible: "none"});
            } else {
                this.setState({tip1Visible: "inline-block"});
            }

            if (this.state.tip2 == 0) {
                this.setState({tip2Visible: "none"});
            } else {
                this.setState({tip2Visible: "inline-block"});
            }
            if (this.state.tip3 == 0) {
                this.setState({tip3Visible: "none"});
            } else {
                this.setState({tip3Visible: "inline-block"});
            }

            if (this.state.tip1 == 0 && this.state.tip2 == 0 && this.state.tip3 == 0) {
                this.setState({customTipVisible: "inline-block"});
                this.setState({notTipVisible: 'inline-block'});
            } else {
                this.setState({customTipVisible: "none"});
                this.setState({notTipVisible: 'inline-block'});
            }


            this.setState({noTipVisible: "inline-block"});
            this.setState({customTipVisible: "none"});


            this.setState({tipSelected: parseFloat($(e.target).val())}, () => {
                var tip = ((parseFloat(this.state.cartTotal) * parseFloat(this.state.tipSelected)) / 100);

                this.setState({tip: tip.toFixed(2)});
                console.log("TIPSELECTED " + this.state.tipSelected)
            });

        }

    };

    closeCustomTip = e => {

        if (this.state.tip1 == 0) {
            this.setState({tip1Visible: "none"});
        } else {
            this.setState({tip1Visible: "inline-block"});
        }

        if (this.state.tip2 == 0) {
            this.setState({tip2Visible: "none"});
        } else {
            this.setState({tip2Visible: "inline-block"});
        }
        if (this.state.tip3 == 0) {
            this.setState({tip3Visible: "none"});
        } else {
            this.setState({tip3Visible: "inline-block"});
        }

        if (this.state.tip1 == 0 && this.state.tip2 == 0 && this.state.tip3 == 0) {
            this.setState({customTipVisible: "none"});
            this.setState({noTipVisible: 'inline-block'});
        } else {
            this.setState({customTipVisible: "none"});
            this.setState({noTipVisible: 'inline-block'});
        }


        this.setState({tipSelected: 0});
        this.setState({tip: 0});

        $('#notip').val('0');


    };
    deleteItem = (product_id, product_price, cart_id, product_qty) => {


        this.state.swalButton.fire({
            title: i18n.t('remove_item_question'),
            allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonText: '  ' + i18n.t('yes') + '  ',
            cancelButtonText: '  ' + i18n.t('no') + '  ',
            customClass: {
                confirmButton: 'form-control bkg-purple-btn font w-auto m-0',
                cancelButton: 'form-control bkg-purple-btn font w-auto m-0 cancelButton'
            },
        }).then((result) => {
            if (result.value) {

                var dbconn = new db();

                var quantity = product_qty;
                if (product_qty == "") {
                    quantity = $('#quant_' + cart_id).val();
                }
                dbconn.deleteOrder(cart_id).then(data => {

                    dbconn.getAllOrder().then(productData => {

                        console.log(productData.length);

                        if (productData.length > 0) {


                            this.calculateCartTotal(true);


                            /*     var cartTotal = parseFloat(this.state.cartTotal);
                                 cartTotal -= (parseFloat(product_price) * parseInt(quantity));
                                 sessionStorage.setItem('cartTotal', parseFloat(cartTotal));
                                 this.setState({cartTotal: parseFloat(cartTotal)});*/
                        } else {
                            sessionStorage.setItem('cartTotal', 0);
                            this.setState({homeRedirectFlag: true});
                            this.setState({editItemProductID: 0});
                            this.cancelCoupon();
                            this.calculateTax(true);

                        }

                    });
                });
            } else {

            }
        });


    };

    editItem = (product_id, cart_id, index) => {

        this.setState({editItemRedirectFlag: true});
        sessionStorage.setItem("product_id", product_id);
        sessionStorage.setItem("type", "E");

        sessionStorage.setItem("loyalty", this.state.productList[index].product_loyalty_enabled);

        if (this.state.productList[index].product_loyalty_enabled == "Y") {
            sessionStorage.setItem("quantity", this.state.productList[index].product_quantity);
        } else {
            sessionStorage.setItem("quantity", parseInt($('#quant_' + cart_id).val()));
        }
        sessionStorage.setItem('editCartID', cart_id);
    };

    render() {
        const {t} = this.props;
        const {open} = this.state;

        if (this.state.nosessionredirect) {
            return (<Redirect to={'/'}/>);
        }

        if (this.state.homeRedirectFlag) {
            return (<Redirect to={'/menu'}/>);
        }
        if (this.state.editItemRedirectFlag) {
            return (<Redirect to={'/product/details'}/>);
        }
        if (this.state.checkoutRedirectFlag) {
            return (<Redirect to={'/checkout/card'}/>);
        }
        if (this.state.guestRedirectFlag) {
            return (<Redirect to={'/checkout/guest'}/>);
        }

        var submitBtnHtml = '';
        var finalNca = 0;


        if (this.state.ncaAmtFlag == 'Y') {
            finalNca = this.state.nca;
            this.setState({ncaOnTipEnabled: "Y"});
        } else {


            if (this.state.ncaMarkup == "N") {
                var nca = 0;

                if (this.state.ncaOnTipEnabled == "Y") {
                    nca = (((parseFloat(this.state.cartTotal) + parseFloat(this.state.tip) + parseFloat(this.state.finalTax)) * parseFloat(this.state.nca)) / 100).toFixed(2);
                } else {
                    nca = (((parseFloat(this.state.cartTotal) + parseFloat(this.state.finalTax)) * parseFloat(this.state.nca)) / 100).toFixed(2);
                }

                finalNca = nca;
            }
        }

        console.log(finalNca + " " + this.state.ncaOnTipEnabled);


        return (
            <div className="mainContainer">
                <header className="">
                    <div className="col-md-12 col-sm-12 col-xs-12 previous-link">
                        <Link to="/menu"></Link>
                        <h2 className="text-center"><strong>{t('view_order')}</strong></h2>
                    </div>
                </header>

                <div className="main-block full-height1">
                    <form name="" className="full-height " method="post" encType="multipart/form-data" action="#popup1">
                        <div className="col-md-6 col-sm-6 col-xs-12 bkg-grey l_content p-b-35 h-100 productList">


                            {this.state.productList.map((item, index) => {

                                var productModifier = [];
                                return (

                                    <div key={index} className="product-block m-0 p-t-b">

                                        <div className="col-md-9 col-sm-9 col-xs-9 left-40p-content">
                                            <div className="row">
                                                <h4>{(localStorage.getItem("store_language") === "en") ? item.product_name : (item["product_name_" + localStorage.getItem("store_language")] !== "") ? item["product_name_" + localStorage.getItem("store_language")] : item.product_name}</h4>


                                                {item.product_modifiers.map((modifier1, index1) => {

                                                    if (productModifier.includes(modifier1.mod_id)) {

                                                    } else {

                                                        var modifier = "";

                                                        var commaCount = 0;
                                                        item.product_modifiers.map((modifier2, index2) => {


                                                            if (parseInt(modifier2.mod_id) == parseInt(modifier1.mod_id)) {

                                                                if (commaCount > 0) {


                                                                    if (modifier2.mod_selected == "Y") {
                                                                        modifier += ", " + ((localStorage.getItem("store_language") === "en") ? modifier2.option_name : (modifier2["option_name_" + localStorage.getItem("store_language")] !== "") ? modifier2["option_name_" + localStorage.getItem("store_language")] : modifier2.option_name) + " " + ((modifier2.mod_price > 0) ? '$' + modifier2.mod_price.toFixed(2) : '');
                                                                        commaCount++;
                                                                    } else {

                                                                        if (modifier2.mod_default == "Y") {

                                                                            modifier += ", "+t('no')+" " + ((localStorage.getItem("store_language") === "en") ? modifier2.option_name : (modifier2["option_name_" + localStorage.getItem("store_language")] !== "") ? modifier2["option_name_" + localStorage.getItem("store_language")] : modifier2.option_name)+ " ";
                                                                            commaCount++;
                                                                        }
                                                                    }
                                                                } else {

                                                                    if (modifier2.mod_selected == "Y") {
                                                                        modifier += ((localStorage.getItem("store_language") === "en") ? modifier2.option_name : (modifier2["option_name_" + localStorage.getItem("store_language")] !== "") ? modifier2["option_name_" + localStorage.getItem("store_language")] : modifier2.option_name) + " " + ((modifier2.mod_price > 0) ? '$' + modifier2.mod_price.toFixed(2) : '');
                                                                        commaCount++;
                                                                    } else {
                                                                        if (modifier2.mod_default == "Y") {
                                                                            modifier += t('no')+" " + ((localStorage.getItem("store_language") === "en") ? modifier2.option_name : (modifier2["option_name_" + localStorage.getItem("store_language")] !== "") ? modifier2["option_name_" + localStorage.getItem("store_language")] : modifier2.option_name) + " ";
                                                                            commaCount++;

                                                                        }
                                                                    }
                                                                }

                                                            }


                                                        });

                                                        if (modifier != "") {
                                                            modifier = ((localStorage.getItem("store_language") === "en") ? modifier1.mod_name : (modifier1["mod_name_" + localStorage.getItem("store_language")] !== "") ? modifier1["mod_name_" + localStorage.getItem("store_language")] : modifier1.mod_name) + ": " + modifier;
                                                        }

                                                        productModifier.push(modifier1.mod_id);

                                                        console.log(modifier);
                                                        return (<p key={modifier1.option_id}>
                                                            <p style={{paddingRight: '10px'}}>{modifier}</p>
                                                        </p>);
                                                    }


                                                })}

                                                {(item.product_notes != "") ?

                                                    <p style={{paddingRight: '10px'}}>{t('special_notes')}: {item.product_notes}</p>

                                                    : ''}

                                                {(item.product_modifiers_isOkey == "N") ?

                                                    <p style={{
                                                        paddingRight: '10px',
                                                        color: "red"
                                                    }}>{t('select_option_inst')}</p>
                                                    : ''}
                                            </div>
                                        </div>

                                        <div className="col-md-3 col-sm-3 col-xs-3 bkg-grey">
                                            <div className="row">
                                                <div className="right-l">
                                                    <div className="product-info">
                                                        {(item.product_loyalty_enabled == "N") ?
                                                            <h3 className="m-b-10 text-dark">$<span
                                                                id={"product_price_" + item.cart_id}>{(((parseFloat(item.product_price) + parseFloat(item.mod_price)) - (item.product_discount_type == "A" ? item.product_discount : (((parseFloat(item.product_price) + parseFloat(item.mod_price)) * item.product_discount) / 100))) * parseInt(item.product_quantity)).toFixed(2)}</span>
                                                            </h3>
                                                            : <h3 className="m-b-10 text-dark"><span
                                                                id={"product_price_" + item.cart_id}>{(parseFloat(item.product_loyalty_price) * parseInt(item.product_quantity)).toFixed(0)} {t('points')}</span>
                                                            </h3>}

                                                        {(item.product_loyalty_enabled == "N") ?

                                                            <div className="input-group">
                                                                {(item.product_discount_type != "H" && item.product_discount_type != "G") ?
                                                                    <span className="input-group-btn">

                                <button type="button"
                                        id={"btn-minus_" + item.cart_id}
                                        name={"btn-minus_" + item.cart_id}
                                        onClick={() => {
                                            this.lessQuantity(item)
                                        }} className="btn-number" data-type="minus"
                                        data-field="quant[2]">
                                                            <span className="quty-icon minus-icon">-</span>
                                                            </button>
							  </span> : ""}
                                                                <input type="text" disabled={true}
                                                                       id={"quant_" + item.cart_id}
                                                                       name={"quant_" + item.cart_id}
                                                                       className="form-control input-number"
                                                                       min="1" max="99"
                                                                       value={item.product_quantity}
                                                                       defaultValue={item.product_quantity}
                                                                       readOnly={true}/>

                                                                {(item.product_discount_type != "H" && item.product_discount_type != "G") ?
                                                                    <span className="input-group-btn">
								  <button type="button"
                                          id={"btn-plus_" + item.cart_id}
                                          name={"btn-plus_" + item.cart_id}
                                          onClick={() => {
                                              this.plusQuantity(item)
                                          }} className="btn-number" data-type="plus"
                                          data-field="quant[2]">
                                                            <span className="quty-icon plus-icon">+</span>
                                                            </button>
							  </span> : ""}
                                                            </div> : ""}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="clearfix"></div>
                                        {(item.isModifierAvailable && item.product_discount_type != "H") ?


                                            <input type="button"
                                                   className="btn-auto"
                                                   name="editItemBtn" id="editItemBtn"
                                                   onClick={() => {
                                                       this.editItem(item.product_id, item.cart_id, index)
                                                   }} value={t('edit')}/>


                                            : ''}

                                        {(item.product_discount_type != "H" && item.product_discount_type != "G") ? (item.product_loyalty_enabled == "N") ?
                                            <input type="button"
                                                   className="btn-auto"
                                                   name="deleteItemBtn" id="deleteItemBtn"
                                                   onClick={() => {
                                                       this.deleteItem(item.product_id, (parseFloat(item.product_price) + parseFloat(item.mod_price)), item.cart_id, "")
                                                   }} value={t('remove')}/> :
                                            <input type="button"
                                                   className="btn-auto"
                                                   name="deleteItemBtn" id="deleteItemBtn"
                                                   onClick={() => {
                                                       this.deleteItem(item.product_id, item.mod_price, item.cart_id, item.product_quantity)
                                                   }} value={t('remove')}/> : ""}


                                    </div>);
                            })
                            }


                        </div>

                        <div className="col-md-6 col-sm-6 col-xs-12 bkg-black full-height cartInfo">

                            <div className="row full-height">


                                <div className="right-r full-height">
                                    <div className="right-r-top row  w-100 bkg-black couponContainer" style={{
                                        padding: "10px",
                                        marginRight: "0px",
                                        marginLeft: "0px",

                                    }}>

                                        <div className="col-md-5 col-sm-5 col-xs-12 bkg-black">
                                            <h4 className="m-t-7" style={{color: "white"}}> {t('coupon_code')}:</h4>
                                        </div>
                                        <div className="col-md-7 col-sm-7 col-xs-12 bkg-black"
                                             id="couponInputContainer">
                                            <div className="input-group">
                                                <input type="text" id="couponInput" style={{height: "40px"}}
                                                       className="form-control"/>
                                                <span className="input-group-btn">
                                                     <input type="button" id="couponBtn" onClick={this.addCoupon}
                                                            style={{margin: "0px"}}
                                                            value={t('add')}/>

                                                </span>
                                            </div>
                                        </div>

                                        <div className="col-md-7 col-sm-7 col-xs-12 bkg-black full-height"
                                             style={{display: "none"}} id="appliedCouponContainer">
                                            <div className="input-group">
                                                <span><h4 id="appliedCouponText"
                                                          style={{color: "white"}}></h4></span>
                                                <span className="input-group-btn">
                                                          <img className="btnClose" onClick={this.cancelCoupon}
                                                               src="/img/closewhite.png"/>


                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    {(this.state.tipEnabled) ?


                                        (<div className="right-r-top float_l w-100 bkg-yellow tipContainer">
                                            <div className="tipBox">
                                                <h3 className="m-t-7" style={{color: "white"}}>{t('want_tip')}</h3>


                                                <ul className="tips">

                                                    <li style={{display: this.state.tip1Visible}}>
                                                        <div key="tip1">
                                                            <input type="radio" id="a25" name="amount"
                                                                   value={this.state.tip1}
                                                                   onChange={this.updateTip}/>
                                                            <label htmlFor="a25">{this.state.tip1}%</label>
                                                        </div>

                                                    </li>
                                                    <li style={{display: this.state.tip2Visible}}>
                                                        <div key="tip2">
                                                            <input type="radio" id="a50" name="amount"
                                                                   value={this.state.tip2}
                                                                   onChange={this.updateTip}/>
                                                            <label htmlFor="a50">{this.state.tip2}%</label>
                                                        </div>
                                                    </li>
                                                    <li style={{display: this.state.tip3Visible}}>
                                                        <div key="tip3">
                                                            <input type="radio" id="a75" name="amount"
                                                                   value={this.state.tip3}
                                                                   onChange={this.updateTip}/>
                                                            <label htmlFor="a75">{this.state.tip3}%</label>
                                                        </div>
                                                    </li>

                                                    <li>
                                                        <div key="otherTip">
                                                            <input type="radio" id="other" name="amount" value="other"
                                                                   onChange={this.updateTip}/>
                                                            <label htmlFor="other">{t('other')}</label>
                                                        </div>
                                                    </li>
                                                    <li style={{display: this.state.noTipVisible}}>
                                                        <div key="noTip">
                                                            <input type="radio" id="notip" name="amount" value="0"
                                                                   onChange={this.updateTip}/>
                                                            <label htmlFor="notip">{t('no_tip')}</label>
                                                        </div>
                                                    </li>
                                                    <li style={{display: this.state.customTipVisible}}>
                                                        <input type="number" min="0" onKeyUp={this.handleKeyUp}
                                                               className="customTip" placeholder="$0.00"
                                                               id="otherAmount" name="numAmount"/>
                                                    </li>
                                                    <li style={{display: this.state.customTipVisible}}>
                                                        <img className="btnClose" onClick={this.closeCustomTip}
                                                             src="/img/close.png"/>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>)
                                        :
                                        ''
                                    }


                                    <div className="right-r-bottom full-height">
                                        <div className="bkg_box_black full-height parameters">
                                            <div className="total_box total_box-100 p-20">
                                                <ul className="m-b-0">
                                                    <li><label>Sub-
                                                        Total</label>${parseFloat(this.state.cartTotal).toFixed(2)}</li>

                                                    {(this.state.couponDiscount > 0) ?
                                                        <li><label>Discount:</label>
                                                            ${this.state.couponDiscount.toFixed(2)}
                                                        </li>
                                                        : ''
                                                    }
                                                    {this.state.tax.map((tax, index) => {

                                                        return (<li key={tax.tax_id}>

                                                            <label>{tax.tax_name} ({tax.tax_percentage}%):</label>

                                                            ${tax.tax_value}</li>);
                                                    })}

                                                    {(finalNca > 0 && this.state.ncaOnTipEnabled == "N") ?

                                                        <li><label>{this.state.ncaAmtName} ({this.state.nca}%):</label>
                                                            ${finalNca}</li>

                                                        : ''
                                                    }

                                                    {(this.state.tip > 0) ?
                                                        <li><label>{t('tip')}:</label>
                                                            ${this.state.tip}
                                                        </li>
                                                        : ''
                                                    }

                                                    {(finalNca > 0 && this.state.ncaOnTipEnabled == "Y") ?

                                                        <li>
                                                            <label>{this.state.ncaAmtName} ({this.state.nca}%):</label>

                                                            ${finalNca}</li>

                                                        : ''
                                                    }

                                                    <li className="line"></li>
                                                    <li className="total_num">
                                                        <label>Total:</label>${(parseFloat(this.state.finalTax) + parseFloat(finalNca) - parseFloat(this.state.couponDiscount) + parseFloat(this.state.tip) + parseFloat(this.state.cartTotal)).toFixed(2)}
                                                    </li>
                                                    {(this.state.totalLoyaltyPoints > 0) ?
                                                        <li><label>{t('points_redeemed')}:</label>
                                                            {this.state.totalLoyaltyPoints}
                                                        </li>
                                                        : ''
                                                    }

                                                </ul>
                                            </div>

                                            <div className="bkg-black bkg-black-pos">
                                                <input type="button" id="CheckoutBtn" style={{margin: "0px"}}
                                                       value={t('checkout')}/>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>

                </div>


                <Modal closeOnEsc={false} closeOnOverlayClick={false} showCloseIcon={false}
                       open={open}
                       onClose={this.onCloseModal} center>
                    <h2>&nbsp;&nbsp;&nbsp;&nbsp;{t('processing_order')}...&nbsp;&nbsp;&nbsp;&nbsp;</h2>

                    <p style={{textAlign: 'center'}}>
                        <img width={'40'} height={'40'} src={'/img/loader.gif'}/>
                    </p>
                </Modal>
                <Notifications options={{zIndex: 9999, width: '100%', top: '50px'}}/>

                <div className="clearfix"></div>
            </div>

        );


    }

    onResize = () => {
        if ($('#productInfo').height() > 0) {

            $('#productInfo').css('height', $('#specificBox').position().top - $('header').height());
            // console.log($('#specificBox').position().top + " " + $(window).height() + " " + $('header').height() + " " + $('#productInfo').height() + " A" + " " + $('#txnDetails').height() + " " + $('#specificBox').height());

            // this.setState({resizeFlag: false});

            //   this.setState({resizeCount: (this.state.resizeCount+1)});


        }

    };
}

export default withRouter(withTranslation()(view_order));


// WEBPACK FOOTER //
// ./src/view_components/view_order.js